import { Link } from "react-router-dom";
import { useState } from "react";

interface AdminNavbarProps {
  onLogout: () => void;
}

export default function AdminNavbar({ onLogout }: AdminNavbarProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-sm">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            className="font-display text-xl md:text-2xl tracking-wide whitespace-nowrap text-brown"
          >
            Entre Elas
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <span className="text-sm font-body text-primary tracking-wide uppercase whitespace-nowrap">
              Área Administrativa
            </span>
            <Link
              to="/"
              className="text-sm font-body text-brown tracking-wide uppercase transition-colors duration-300 hover:text-primary whitespace-nowrap"
            >
              Voltar ao site
            </Link>
            <button
              onClick={onLogout}
              className="text-sm font-body text-brown tracking-wide uppercase transition-colors duration-300 hover:text-red-500 whitespace-nowrap cursor-pointer"
            >
              Sair
            </button>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menu"
          >
            <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-xl text-brown`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white/98 backdrop-blur-md border-t border-beige">
          <div className="flex flex-col px-6 py-4 gap-3">
            <span className="text-left text-sm font-body text-primary tracking-wide uppercase py-2 whitespace-nowrap">
              Área Administrativa
            </span>
            <Link
              to="/"
              onClick={() => setMobileOpen(false)}
              className="text-left text-sm font-body text-brown tracking-wide uppercase py-2 hover:text-primary transition-colors whitespace-nowrap"
            >
              Voltar ao site
            </Link>
            <button
              onClick={() => {
                setMobileOpen(false);
                onLogout();
              }}
              className="text-left text-sm font-body text-brown tracking-wide uppercase py-2 hover:text-red-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              Sair
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}